module.exports = __webpack_public_path__ + "prod/1.42.2/img/sealbg.d3a8f2e5.png";